export default __webpack_public_path__ + "static/media/womenWeddingDress.64388550.svg";